import React from 'react';
import styled from 'styled-components';
import FlexboxContainer from 'components/UI/FlexboxContainer';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FontWeight } from 'lib/styles';
import { Text } from 'styles/themeColors';
import * as Cons from 'data/Consignment';
import { TEXT_LABELS } from 'constants/order';
import { DateTime } from 'luxon';

const LabelText = styled.span`
  display: block;
  font-weight: ${FontWeight.medium};
  text-align: left;
  margin-bottom: 5px;
  color: ${Text.primary};
  font-size: 15px;
`;

interface Props {
  isRental?: boolean;
  consignmentData?: Cons.ConsignmentDetails;
  datesFormat?: "MMM dd, yyyy" | "yyyy MMM dd",
  showNewDates?: boolean;
  showOriginal?: boolean;
  margin?: string;
}

export default function RentalDates({ consignmentData, datesFormat = "MMM dd, yyyy", showNewDates = false, showOriginal = true, margin="25px 0px"}: Props) {
  const startDateValue = showNewDates
    ? consignmentData?.modificationEntry?.newStartDate
    : showOriginal
      ? consignmentData?.rentalStartDate
      : consignmentData?.modificationEntry?.originalStartDate;

  const endDateValue = showNewDates
    ? consignmentData?.modificationEntry?.newEndDate
    : showOriginal
      ? consignmentData?.rentalEndDate
      : consignmentData?.modificationEntry?.originalEndDate;

  return (
    <>
      <FlexboxContainer flexDirection="row" margin={margin}>
        <FlexboxContainer
          flexDirection="column"
          width="150px"
          margin="0 0 0 4px"
        >
          <LabelText>{showNewDates ? TEXT_LABELS.NEW_START_DATE : TEXT_LABELS.START_DATE}</LabelText>
          <DatePicker
            value={startDateValue ? DateTime.fromISO(startDateValue) : null}
            format={datesFormat}
            slotProps={{ textField: { size: 'small' } }}
            onChange={() => {}}
            disabled
          />
        </FlexboxContainer>
        <FlexboxContainer
          flexDirection="column"
          width="150px"
          margin="0 0 0 4px"
        >
          <LabelText>{showNewDates ? TEXT_LABELS.NEW_END_DATE : TEXT_LABELS.END_DATE}</LabelText>
          <DatePicker
            value={endDateValue ? DateTime.fromISO(endDateValue) : null}
            format={datesFormat}
            slotProps={{ textField: { size: 'small' } }}
            onChange={() => {}}
            disabled
          />
        </FlexboxContainer>
      </FlexboxContainer>
    </>
  );
}
